import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import ProductImage from '../ProductImage';
import {
  productHasSizes,
  getTotalProductPrice,
  checkEmpty,
  getProductName,
  getClassificationClass,
} from '../../helpers/productHelper';
import * as modal from '../../reducers/modalReducer';
import * as userReducer from '../../reducers/userReducer';
import * as addressReducer from '../../reducers/addressReducer';
import { getSpecificIcon } from '../../helpers/producttypes.js';
import { BODY_TEXT_COLOR } from '../../config/colors';
import { holdProduct } from '../../reducers/holdProductReducer';
import { isAttribute as isAttributeUtil, getNumberViewVal, getUomDisplayVal } from '../../helpers/attribute_util';
import './style.css';
import { Link } from 'react-router-dom';
import { isKioskCustomerSelector } from '../../selectors/userSelectors';
import {shouldResetShoppingCart, isUserAbleToAddProductByCustomerType, isSalesChannelNameItemMismatch} from '../../selectors/cartSelectors';
import {
  isShippingForm,
  isPaymentKiosk as isPaymentKioskSelector,
  isMainBoard,
  getColors,
} from '../../selectors/configSelectors';
import Banner from '../Banner/banner';
import { getDiscount } from '../../helpers/discountUtils';
import LabDataValue from '../LabDataValue/lab_data_value';
import { resetCart } from '../../reducers/cartReducer';
import { adultCanOnlyBuyRecModalProps, cannotMixItemsFromDifferentSalesChannelsModalProps, confirmResetCartModal, confirmResetCartModalProps } from "../../helpers/cartHelper";

import { PRODUCT_ATTRIBUTE } from '../../const/attribute';
import { getStyle as getClassificationStyle } from '../../helpers/classification_util';
import { getCurrentCustomerType } from '../../selectors/customer_type_selector';
import SimplePlusIcon from '../../icons/SimplePlusIcon';
import { getCurrentLayoutType } from '../../selectors/viewSelectors';
import LayoutType from '../../const/layout_type';
import { SAME_SALES_CHANNEL_MESSAGE } from '../../const/cart_const';
import { getQueryParameters } from '../../services/uri';

const $ = require('jquery');

const styles = {
  price: {
    fontSize: '20px',
    fontFamily: 'Futura-Bold',
    color: BODY_TEXT_COLOR,
  },
  weight: { margin: '4px 0 0 2px', fontSize: '11px' },
  weightKiosk: { margin: '4px 0 0 2px', fontSize: '40px' },
  labelStyle: { fontWeight: 700 },
};
class Product extends Component {
  buttonStyle = { border: `1px solid #${this.props.secondaryColor}` };

  addToCartBtnStyle = {
    border: '1px solid',
    boxShadow: 'none',
    borderColor: `#${this.props.secondaryColor}`,
  };

  addToCartBtn = this.props.isPhone && this.props.layoutType === LayoutType.GRID
    ? { zIndex: 1 }
    : {
      position: 'absolute', right: 12, bottom: 2, zIndex: 1,
    };

  isCompactAddToCartButtonStyle = () => this.props.isPhone && this.props.layoutType === LayoutType.GRID;

  menuItem = this.props.isPhone
    ? { padding: '0 0 15px' }
    : { padding: '0 0 55px' };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.product.id !== nextProps.product.id
      || this.props.isUser !== nextProps.isUser
      || this.props.currentCustomerType !== nextProps.currentCustomerType
      || this.props.layoutType !== nextProps.layoutType
    );
  }

  getSecondaryColor = () => `#${this.props.secondaryColor}`

  isAttribute = (productType, attributeName) => {
    if (productType === 'CARTRDIGE' && attributeName === 'SIZE') {
      return false;
    } if (
      productType === 'EXTRACT'
      && (attributeName === 'SIZE' || attributeName === 'SUBTYPE')
    ) {
      return true;
    } if (
      productType === 'EDIBLE'
      && (attributeName === 'MGDOSE'
        || attributeName === 'SUBTYPE'
        || attributeName === 'TOTALDOSES')
    ) {
      return true;
    } if (
      productType === 'PLANT'
      && (attributeName === 'MEDIUM' || attributeName === 'SIZE')
    ) {
      return true;
    } if (productType === 'PRE-ROLL' && attributeName === 'SIZE') {
      return true;
    } if (productType === 'TOPICAL' && attributeName === 'MGDOSE') {
      return true;
    }
    return false;
  };

  getPriceTag = (p, specificProduct) => {
    const isSize = productHasSizes(p.type);
    const priceWith = getTotalProductPrice(
      specificProduct,
      this.props.menuRoundTax,
    );

    return { isSize, price: priceWith.toFixed(2) };
  };

  getBrandNameStyle = () => {
    return this.props.isPhone && this.props.layoutType === LayoutType.LIST
      ? { fontSize: 12 }
      : { };
  }

  getProductNameStyle = () => {
    const style = { color: `#${this.props.textColor}` };

    return this.props.isPhone && this.props.layoutType === LayoutType.LIST
      ? { ...style, fontSize: '32px', lineHeight: '32px', margin: '0 0 12px -2px' }
      : style;
  }

  getProductAttributesStyle = () => {
    return this.props.isPhone && this.props.layoutType === LayoutType.LIST
      ? { fontSize: '12px' }
      : { };
  }

  getProductIndexOfSmallestSize = (productList) => {
    // returns product Index of 3.5 size, or first smallest size
    const products = {};
    $.map(productList, (e, i) => {
      products[e.weight] = i;
    });

    let productIndex = -1;
    if ('3.5' in products) {
      productIndex = products['3.5'];
    } else {
      Object.keys(products).sort((a, b) => Number(a) - Number(b));
      // smallest size
      if (productList.length > 0) productIndex = 0;
    }
    return Number(productIndex);
  };

  onImgLoaded = () => {
    this.setState({
      ringSpinner: false,
    });
  };

  imgError = (event) => {};

  addToCart = () => {
    const { isKioskCustomer } = this.props;

    if (!isKioskCustomer) {
      if (!this.props.isUser) {
        this.props.holdProduct({
          type: 'short',
          product: this.props.product,
          index: this.props.productIndex,
          // products: this.props.products,
          pos: this.props.view.pos,
          url: this.props.router.location.pathname,
        });
        this.props.openLoginForm();
        return;
      }
      if (this.props.isShippingForm && !this.props.currentAddress) {
        this.props.openShippingForm({ handleClose: this.addToCart });
        return;
      }
    }

    this.props.open1XproductView({
      product: this.props.product,
      productIndex: this.props.productIndex,
    });
  };

  handleAddToCartClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    if (!this.props.isUserAbleToAddProductByCustomerType) {
      this.props.openMessageModal(adultCanOnlyBuyRecModalProps());
      return;
    }

    if (this.props.isSalesChannelNameItemMismatch) {
      this.props.openConfirmModal(  
        confirmResetCartModal(
          () => {
            this.props.resetCart();
            this.addToCart();
          },
          SAME_SALES_CHANNEL_MESSAGE
        )
      );
      return;
    }

    if (this.props.shouldResetShoppingCart) {
      this.props.openConfirmModal(
        confirmResetCartModalProps(() => {
          this.props.resetCart();
          this.addToCart();
        })
      );
      return;
    }

    this.addToCart();
  };

  getDollarSign = () => {
    const { isPaymentKiosk } = this.props;
    if (isPaymentKiosk) {
      return <span className="dollar" style={{ fontSize: '25px' }}>$</span>;
    }
    return <span className="dollar">$</span>;
  }

  getItemClass = () => {
    const itemClass = `menu-item ${this.props.isPaymentKiosk ? 'payment-kiosk-item' : ''}`;
    const {
      layoutType,
      isPhone,
    } = this.props;

    return isPhone
      ? `${itemClass} ${layoutType === LayoutType.GRID ? 'grid' : 'list'}`
      : itemClass;
  }

  getLayoutType = () => {
    const {
      layoutType,
      isPhone,
    } = this.props;

    return isPhone ? layoutType : undefined;
  }

  isAddToCartBtn = () => {
    const { isPaymentKiosk, isMainBoard } = this.props;
    return !isPaymentKiosk && !isMainBoard;
  }

  renderAttributes(product) {
    const attributeStyle = this.getProductAttributesStyle();

    const classification = product.classifications.map(
      (classificationName) => (
        <span
          key={classificationName}
          className={`classification ${getClassificationClass(product)}`}
          style={{...getClassificationStyle(classificationName, this.props.colors), ...attributeStyle}}
        >
          {classificationName}
        </span>
      ),
    );
    const subTypes = product.subTypes.map((subType) => (
      <span key={subType} style={attributeStyle} className="attribute">
        {subType}
      </span>
    ));
    const unitOfMeasurement = getUomDisplayVal(product.unitOfMeasurement);
    const productSize = isAttributeUtil(product, PRODUCT_ATTRIBUTE.SIZE) ? (
      <span className="attribute" style={attributeStyle}>
        {getNumberViewVal(product.size)}
&nbsp;
        {unitOfMeasurement}
      </span>
    ) : undefined;
    const medium = <span className="attribute" style={attributeStyle}>{product.medium}</span>;
    const mgDose = product.totalDoses > 0 ? (
      <span className="attribute">
        {product.totalDoses}
        {' '}
DOSES
      </span>
    ) : null;
    const mgTotal = product.mgDose ? (
      <span className="attribute" style={attributeStyle}>
        {product.mgDose}
        {' '}
MG THC
      </span>
    ) : null;

    return (

      <div className="item-text-3 uppercase" style={attributeStyle}>
        {classification}
        {product.thc
          && product.thc !== '-.-' && (
            <span className="attribute"><LabDataValue style={{ ...styles.labResultTitle, ...attributeStyle }} name="THC" value={product.thc} /></span>
        )}
        {this.isAttribute(product.type, 'SUBTYPE') && (
        <span title="Subtype">{subTypes}</span>
        )}
        {productSize && this.isAttribute(product.type, 'SIZE') && (
        <span title="size">{productSize}</span>
        )}
        {this.isAttribute(product.type, 'MEDIUM') && (
        <span>{medium}</span>
        )}
        {this.isAttribute(product.type, 'MGDOSE') && (
        <span>{mgDose}</span>
        )}
        {(this.isAttribute(product.type, 'MGDOSE') && (
        <span>{mgTotal}</span>
        ))}
      </div>
    );
  }

  renderAddToCartButton() {
    const {
      isPhone,
      layoutType,
    } = this.props;

    return isPhone
      && layoutType === LayoutType.GRID ? (
        <div
          className="add-to-cart"
          onClick={e => this.handleAddToCartClick(e)}
        >
          <SimplePlusIcon
            style={{ height: 30, width: 'auto' }}
            color={this.getSecondaryColor()}
          />
        </div>
      )
      : (
        <AddToCartContainer
          isPhone={isPhone}
          compact={this.isCompactAddToCartButtonStyle()}
        >
          <RaisedButton
            onClick={e => this.handleAddToCartClick(e)}
            backgroundColor="#FFF"
            labelColor={this.getSecondaryColor()}
            labelStyle={styles.labelStyle}
            label="Add To Cart"
            buttonStyle={this.buttonStyle}
            style={this.addToCartBtnStyle}
          />
        </AddToCartContainer>
      );
  }

  render() {
    const { isEcommerceEnabled } = this.props;
    const { product } = this.props;
    const brand = checkEmpty(product.brand);
    const name = getProductName(product);

    const sizes = product.productList.filter((size) => {
      const sizePositive = size.priceSell > 0;
      if (!sizePositive) {
        console.error(`${JSON.stringify(product)} sellPrice is 0`);
      }
      return sizePositive;
    });
    if (sizes.length === 0) {
      return null;
    }
    // return index of 3.5 G or nearest smallest size index
    const defaultProductIndex = this.getProductIndexOfSmallestSize(sizes);
    const specificProduct = sizes[defaultProductIndex];
    const getPriceTagObj = this.getPriceTag(product, specificProduct);
    const weightClass = this.props.isPaymentKiosk ? styles.weightKiosk : styles.weight;
    const priceTag = (getPriceTagObj, strike = false) => (
      <div
        className="menu-item-pricetag"
        style={{
          color: BODY_TEXT_COLOR,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {this.getDollarSign()}
        {this.props.isPaymentKiosk
          ? <PriceSpanKiosk>{getPriceTagObj.price}</PriceSpanKiosk>
          : <PriceSpan>{getPriceTagObj.price}</PriceSpan>
        }
        {getPriceTagObj.isSize && (
          <span style={weightClass}>
            {`/ ${specificProduct.weight}`}
            {getUomDisplayVal(specificProduct.unitOfMeasurement)}
          </span>
        )}
      </div>
    );

    const preDiscountPriceTag = getPriceTagObj => (
      <div
        className="menu-item-pricetag"
        style={{
          color: BODY_TEXT_COLOR,
          display: 'flex',
          alignItems: 'center',
          textTransform: 'line-through',
        }}
      >
        {this.getDollarSign()}
        {this.props.isPaymentKiosk
          ? <PriceSpanKiosk>{getPriceTagObj.price}</PriceSpanKiosk>
          : <PriceSpanStrike>{getPriceTagObj.price}</PriceSpanStrike>
        }
      </div>
    );

    const wrapperClass = `wrapper ${this.props.isPaymentKiosk ? 'payment-kiosk-item' : ''}`;
    const typeIconClass = `type-icon-wrapper ${this.props.isPaymentKiosk ? 'payment-kiosk-type-icon svg' : ''}`;
    const discount = getDiscount(product.discounts, getPriceTagObj.price, 'ONLINE_MENU') || undefined;
    const attributes = this.renderAttributes(product);

    return (
      <div className={this.getItemClass()} onClick={this.props.onClick} style={this.menuItem}>
        <Link className="link" to={{ pathname: this.props.url, search: getQueryParameters() }}>
          <div className="item">
            <div className={typeIconClass}>
              <span className="type-icon">
                {getSpecificIcon(product.type, BODY_TEXT_COLOR)}
                {' '}
              </span>
              {' '}
            </div>
            <ProductImage
              imageUrl={product.largeImage}
              noProductImage={this.props.noProductImage}
              scrollPosition={this.props.scrollPosition}
              layoutType={this.getLayoutType()}
            />

            { discount
                  && (
                  <div className="banner-wrapper">
                    <Banner
                      discount={discount}
                    />
                  </div>
                  )
                }
            <div className={wrapperClass} style={{ position: 'relative' }}>
              <div style={{ textAlign: 'left' }}>
                <div className="item-text-1 uppercase" style={this.getBrandNameStyle()}>{brand}</div>
                <div
                  className="item-text-2 uppercase"
                  style={this.getProductNameStyle()}
                >
                  {name}
                </div>
              </div>
            </div>

            <Aligner>
              {attributes}
              { discount
                    && (
                    <div className="item-text-4">
                      {preDiscountPriceTag(getPriceTagObj)}
                      {'  '}
                      {priceTag({ ...getPriceTagObj, ...{ price: discount.discountPrice.toFixed(2) } })}
                    </div>
                    )
                  }
              { !discount
                    && <div className="item-text-4">{priceTag(getPriceTagObj)}</div>
                  }
              {isEcommerceEnabled && this.isAddToCartBtn() && (
                this.renderAddToCartButton()
              )}
            </Aligner>
          </div>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  currentAddress: addressReducer.isAddressSelected(state),
  isUser: userReducer.isUser(state),
  textColor: state.config.textColor,
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
  isPhone: state.config.isPhone,
  view: state.view,
  router: state.router,
  menuRoundTax: state.config.menuRoundTax,
  isEcommerceEnabled: state.config.isEcommerceEnabled,
  noProductImage: state.config.NO_PRODUCT_IMAGE,
  isKioskCustomer: isKioskCustomerSelector(state),
  isShippingForm: isShippingForm(state),
  isPaymentKiosk: isPaymentKioskSelector(state),
  isMainBoard: isMainBoard(state),
  colors: getColors(state),
  currentCustomerType: getCurrentCustomerType(state),
  shouldResetShoppingCart: shouldResetShoppingCart(state, props.product),
  isUserAbleToAddProductByCustomerType: isUserAbleToAddProductByCustomerType(state, props.product),
  isSalesChannelNameItemMismatch: isSalesChannelNameItemMismatch(state),
  layoutType: getCurrentLayoutType(state),
});

const mapDispatchToProps = dispatch => ({

    open1XproductView: props =>
      dispatch(
        modal.openModal({
          modalType: '1X_PRODUCT_VIEW',
          modalProps: props,
        }),
      ),
    openLoginForm: () =>
      dispatch(
        modal.openModal({
          modalType: 'LOGIN_FORM',
          modalProps: {
            raisedClass: 'raise',
          },
        }),
      ),
    openShippingForm: props =>
      dispatch(
        modal.openModal({
          modalType: 'SHIPPING_FORM',
          modalProps: props,
        }),
      ),
    openConfirmModal: props =>
      dispatch(
        modal.openModal({
          modalType: "CONFIRM_MODAL",
          modalProps: props
        })
      ),
    openMessageModal: props =>
      dispatch(
        modal.openModal({
          modalType: "MESSAGE_MODAL",
          modalProps: props
        })
      ),
    resetCart: () => dispatch(resetCart()),holdProduct: product => dispatch(holdProduct(product)),
  });

export default connect(mapStateToProps, mapDispatchToProps)(Product);

const PriceSpan = styled.span`
  font-size: 20px;
  font-family: "futura-bold";
  color: ${BODY_TEXT_COLOR};
`;

const PriceSpanStrike = styled.span`
  font-size: 20px;
  font-family: "futura-bold";
  color: #c7c7c7;
  text-decoration: line-through;
`;

const PriceSpanKiosk = styled.span`
  font-size: 40px;
  font-family: "futura-bold";
  color: ${BODY_TEXT_COLOR};
`;
const Aligner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-left: 14px;
`;
const AddToCartContainer = styled.div`
  z-index: 1;
  ${props => !props.compact && `
    position: absolute;
    right: 12px;
    bottom: 2px;
  `}
  ${props => !props.isPhone && `
    @media (max-width: 1288px) {
      position: relative;
      right: 0;
      bottom: 0;
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/Product/Product.jsx